import { Menu } from "../models/menu.model";

export const MENU: Array<Menu> = [
  {
    icon: 'home',
    route: '/admin',
    title: 'Inicio',
  },
  {
    icon: 'dashboard',
    route: '/admin/modulos',
    title: 'Módulos',
  },
  {
    icon: 'app_settings_alt',
    route: '/admin/telefonos-sistema',
    title: 'Teléfonos del sistema',
  },
  {
    icon: 'people_alt',
    route: '/admin/perfiles',
    title: 'Perfiles',
  },
  {
    icon: 'category',
    route: '/admin/tipos-pregunta',
    title: 'Tipos de pregunta',
  },
  {
    icon: 'person',
    route: '/admin/usuarios',
    title: 'Usuarios',
  }
];

export const COMPANY_MENU: Array<Menu> = [
  {
    icon: 'home',
    route: 'empresas/{idEmpresa}',
    title: 'Inicio',
  },
  {
    icon: 'ballot',
    route: 'empresas/{idEmpresa}/encuestas',
    title: 'Encuestas',
  },
  {
    icon: 'send',
    route: 'empresas/{idEmpresa}/lotes',
    title: 'Lotes de envío',
  },
  {
    icon: 'person',
    route: 'empresas/{idEmpresa}/permisos',
    title: 'Permisos',
  },
  {
    icon: 'settings',
    route: 'empresas/{idEmpresa}/settings',
    title: 'Configuración',
  }
];